import { RouteObject } from 'react-router-dom';

import AuctionsList from 'pages/auctions/AuctionList/AuctionsList';
import CreateAuctionPage from 'pages/auctions/CreateAuction/CreateAuction';
import AuctionDetailPage from 'pages/auctions/AuctionDetail/AuctionDetail';
import EditAuctionPage from 'pages/auctions/CreateAuction/EditAuction';

import SellerPage from 'pages/seller/SellerPage';

import LoginPage from 'pages/users/Login/Login';
import Profile from 'pages/users/Profile/Profile';

import NotFound from 'pages/common/errors/NotFound';
import App from 'App';

interface Route {
  path: string;
  element: JSX.Element;
}

const routes: Route[] = [
  { path: '/auctions', element: <AuctionsList /> },
  { path: '/auctions/new', element: <CreateAuctionPage /> },
  { path: '/auctions/:auctionId', element: <AuctionDetailPage /> },
  { path: '/auctions/:auctionId/edit', element: <EditAuctionPage /> },
  { path: '/seller/*', element: <SellerPage /> },
  { path: '/auth/login', element: <LoginPage /> },
  { path: '/users/:userId', element: <Profile /> },
];

const routeObjects: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    children: routes.map((route) => route),
  },
  { path: '*', element: <NotFound /> },
];

export default routeObjects;
